module.exports = __webpack_public_path__ + "img/battle.831746a1.png";